export const checkFavOrNot = (checkData , favData) => {
  return favData.find((el) => el.id === checkData.id);
}